module.exports = __webpack_public_path__ + "static/2005-leaves-0ae2550fa43ee2ed92e258a798116376.jpg";